import * as React from "react";
import { Box, Grid, BoxProps } from "@material-ui/core";
import * as styles from "./styles.scss";
import cx from "classnames";
import { SvgIcon } from "../../../../components";

import { ICourse } from "../../Filestorage/types";
import { MUITooltip } from "../Tooltip";

interface IProps extends BoxProps {
  course: ICourse;
  big?: boolean;
  small?: boolean;
  onClick?: any;
  iconLabel?: any;
}

export const CourseCard = (props: IProps) => {
  const ref = React.useRef(null);

  const [bigIcon, setBigIcon] = React.useState(false);

  React.useEffect(() => {
    setBigIcon(props.big && ref.current && ref.current.clientHeight > 60);
  });

  return (
    <Grid item xs>
      <Grid container alignItems="stretch" spacing={2}>
        <Grid item className={styles.flexCentered}>
          <Box
            bgcolor="grey.A200"
            className={cx({
              [styles.icon]: true,
              [styles.small]: props.small,
              [styles.big]: bigIcon,
            })}
          >
            {props.course.icon ? (
              <img src={`/media/80/${window.btoa(props.course.icon)}`} />
            ) : (
              <SvgIcon type="courses-xsmall" />
            )}
            {props.iconLabel ? (
              <div className={styles.iconLabel}>{props.iconLabel}</div>
            ) : (
              ""
            )}
          </Box>
        </Grid>
        <Box clone alignSelf="center">
          {props.children ? (
            <Grid item xs className={styles.progress}>
              <Grid container>
                <Grid item xs={12}>
                  <MUITooltip
                    dark
                    placement="bottom"
                    title={props.course.name}
                  >
                    <Box className={styles.textSmall}>{props.course.name}</Box>
                  </MUITooltip>
                </Grid>
                {props.children}
              </Grid>
            </Grid>
          ) : (
            <Grid item xs ref={ref}>
              {props.small ? (
                <Box fontWeight={600}>{props.course.name}</Box>
              ) : (
                <Box
                  my="-2px"
                  className={cx({
                    [styles.text]: true,
                    [styles.big]: props.big,
                  })}
                >
                  {props.course.name}
                </Box>
              )}
            </Grid>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
